//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Table from "@/components/FilterTable/Table.vue";

const DEFAULT_FORMAT = value => (value ? value : "N/A");

const TABLE_LIST_COLUMNS = [
  {
    name: "id",
    required: false,
    label: "#ID",
    align: "left",
    field: row => row.id,
    format: DEFAULT_FORMAT,
    sortable: false
  },
  {
    name: "nielsen-area",
    required: false,
    align: "left",
    label: "Área Nielsen",
    field: row => row.value,
    format: DEFAULT_FORMAT,
    sortable: false
  },
  // {
  //   name: "district",
  //   required: false,
  //   align: "left",
  //   label: "Distrito",
  //   field: row => row.district,
  //   format: DEFAULT_FORMAT,
  //   sortable: false
  // },
  // {
  //   name: "county",
  //   required: false,
  //   align: "left",
  //   label: "Concelho",
  //   field: row => row.county,
  //   format: DEFAULT_FORMAT,
  //   sortable: false
  // },
  // {
  //   name: "burrough",
  //   required: false,
  //   align: "left",
  //   label: "Freguesia",
  //   field: row => row.burrough,
  //   format: DEFAULT_FORMAT,
  //   sortable: false
  // }
];

export default {
  name: "GeographyTable",
  props: ["tableClass", "bordered", "data", "recordsTotal", "loading"],
  components: {
    Table
  },
  mounted: function() {},
  data: () => ({
    separator: "horizontal",
    columns: TABLE_LIST_COLUMNS,
    filteredData: []
  }),
  methods: {
    fetchRowData: function(index) {
      let data = this.data[index];
      this.$emit("clicked-row", data);
    },
    renderRightSide: function(event) {
      this.$emit("clicked-row", { ...event });
    },
    updateFilter: function(event) {
      this.$emit("filter-changed", event);
    }
  }
};
